var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['suggestion'],on:{"click":function($event){return _vm.sendSuggestion()}}},[_vm._v(" "+_vm._s(_vm.suggestion.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }